import React, { useContext } from "react";

import "./style.scss";
import data from "./data";
import { useStaticQuery, graphql } from "gatsby";
import { LanguageContext, text } from "../../container/language";
import moment from "moment";
import Button from "../Button";
import Link from "../../utils/Link";
import { useTranslation } from "react-i18next";
import { HomePadding } from "../HomePadding";

const getUri = (slug) => {
  return `/lajme/${slug}`;
};

const QuickNews = () => {
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  const {
    api: { newsArticles },
  } = useStaticQuery(graphql`
    {
      api {
        newsArticles(limit: 3, sort: "created_at:desc") {
          id
          created_at
          publishDate
          title {
            id
            text_sq
            text_en
          }
          displayTitle
          slug
        }
      }
    }
  `);
  const [mainArticle, ...rest] = newsArticles;

  return (
    <HomePadding>
      <div className="gray-block">
        <div className="quick-news">
          <div className="quick-news__column">
            <div className="quick-news__inner">
              <div className="quick-news__item quick-news__item--primary">
                <div className="quick-news__label">
                  {t("pages.news.latestNews")}
                </div>
                <time className="quick-news__date">
                  <font>
                    <font>
                      {moment(
                        mainArticle.publishDate || mainArticle.created_at
                      ).format("DD/MM/YYYY")}
                    </font>
                  </font>
                </time>
                <h2 className="quick-news__title">
                  {" "}
                  <Link to={getUri(mainArticle.slug)}>
                    <font>
                      <font>{text(mainArticle.title, userLanguage)}</font>
                    </font>
                  </Link>{" "}
                </h2>
                <div className="quick-news__row">
                  <Link to={"/lajme"}>
                    <Button>{t("pages.news.allNews")}</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="quick-news__column">
            <div className="quick-news__inner">
              {rest.map((item) => (
                <div key={item.id} className="quick-news__item">
                  <time className="quick-news__date">
                    <font>
                      <font>
                        {moment(item.publishDate || item.created_at).format(
                          "DD/MM/YYYY"
                        )}
                      </font>
                    </font>
                  </time>
                  <h3 className="quick-news__title">
                    {" "}
                    <Link to={getUri(item.slug)}>
                      <font>
                        <font>{text(item.title, userLanguage)}</font>
                      </font>
                    </Link>{" "}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </HomePadding>
  );
};

export default QuickNews;
